import { useEffect } from 'react';
import { logComponentEvent } from '../logging';

export function useEventOnMount(componentName, eventName, options, shouldLog = true) {
  useEffect(() => {
    if (shouldLog) {
      logComponentEvent(componentName, eventName, options);
    }
  }, []);
}
